(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sher-help-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sher-help-contact')) {
    customElements.define('sher-help-contact', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-ready')) return;
        this.search = this.querySelector('[data-help-search]');
        this.groups = [...this.querySelectorAll('[data-help-group]')];
        this.buttons = [...this.querySelectorAll('[data-help-category]')];
        this.activeCategory = 'shipping';
        this.search.addEventListener('input', () => this.filter());
        this.search.addEventListener('search', () => this.filter());
        this.querySelector('[data-help-clear]').addEventListener('click', () => { this.search.value = ''; this.filter(); this.search.focus(); });
        this.buttons.forEach(button => button.addEventListener('click', () => { this.activeCategory = button.dataset.helpCategory; this.search.value = ''; this.filter(); }));
        this.addEventListener('shopify:block:select', event => {
          const detail = event.target.closest('details');
          if (!detail) return;
          this.activeCategory = detail.closest('[data-help-group]').dataset.helpGroup;
          this.search.value = '';
          this.filter();
          detail.open = true;
        });
        this.setAttribute('data-ready', '');
        this.filter();
      }
      filter() {
        const normalise = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        const query = normalise(this.search.value.trim());
        const words = query.split(/\s+/).filter(Boolean);
        let count = 0;
        this.buttons.forEach(button => button.setAttribute('aria-pressed', String(!query && button.dataset.helpCategory === this.activeCategory)));
        this.groups.forEach(group => {
          let visible = 0;
          group.querySelectorAll('details').forEach(detail => {
            const text = normalise(detail.textContent);
            const match = query ? words.every(word => text.includes(word)) : group.dataset.helpGroup === this.activeCategory;
            detail.hidden = !match;
            if (!match) detail.open = false;
            if (match) visible++;
          });
          group.hidden = visible === 0;
          count += visible;
        });
        this.querySelector('[data-help-clear]').hidden = !query;
        this.querySelector('[data-help-empty]').hidden = count !== 0;
        this.querySelector('[data-help-status]').textContent = this.dataset.resultsLabel.replace('[count]', count);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sher-home-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sher-home-reviews')) {
    customElements.define('sher-home-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.source = this.querySelector('[data-review-source]');
        this.carousel = this.querySelector('[data-review-carousel]');
        this.track = this.querySelector('[data-review-track]');
        this.dots = this.querySelector('[data-review-dots]');
        this.previous = this.querySelector('[data-review-previous]');
        this.next = this.querySelector('[data-review-next]');
        this.status = this.querySelector('[data-review-status]');
        this.excerpts = new Map(Array.from(this.querySelector('[data-review-excerpts]').content.children, node => [node.dataset.reviewId, node.dataset.excerpt]));
        const options = { signal: this.controller.signal };
        this.previous.addEventListener('click', () => this.goTo(this.activeIndex() - this.columns()), options);
        this.next.addEventListener('click', () => this.goTo(this.activeIndex() + this.columns()), options);
        this.dots.addEventListener('click', event => {
          const button = event.target.closest('[data-index]');
          if (button) this.goTo(Number(button.dataset.index));
        }, options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.updateNavigation());
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          const delta = (event.key === 'ArrowRight' ? 1 : -1) * direction * this.columns();
          this.goTo(event.key === 'Home' ? 0 : event.key === 'End' ? this.records.length : this.activeIndex() + delta);
        }, options);
        this.sourceObserver = new MutationObserver(() => {
          cancelAnimationFrame(this.refreshFrame);
          this.refreshFrame = requestAnimationFrame(() => this.refresh());
        });
        this.sourceObserver.observe(this.source, { childList: true, subtree: true, characterData: true });
        this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
        this.resizeObserver.observe(this.track);
        this.refresh();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.sourceObserver?.disconnect();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.scrollFrame);
        cancelAnimationFrame(this.refreshFrame);
        this.signature = null;
      }
      normalize(value) { return (value || '').replace(/\s+/g, ' ').trim(); }
      refresh() {
        const seen = new Set();
        const records = [];
        for (const item of this.source.querySelectorAll('.jdgm-carousel-item')) {
          const body = this.normalize(item.querySelector('.jdgm-carousel-item__review-body')?.textContent);
          const name = this.normalize(item.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent);
          const link = item.querySelector('a.jdgm-carousel-item__product');
          const product = this.normalize(item.querySelector('.jdgm-carousel-item__product-title')?.textContent);
          const ratingNode = item.querySelector('.jdgm-carousel-item__review-rating');
          const ratingLabel = ratingNode?.getAttribute('aria-label') || '';
          const numericRating = parseFloat(ratingLabel.replace(',', '.'));
          const filled = ratingNode?.querySelectorAll('.jdgm--on').length || 0;
          const halves = ratingNode?.querySelectorAll('.jdgm--half').length || 0;
          const rating = Math.max(0, Math.min(5, Number.isFinite(numericRating) ? numericRating : filled + halves / 2));
          const id = item.dataset.reviewId || [name, body, product].join('|');
          if (!body || !name || !product || !link || !ratingLabel || seen.has(id)) continue;
          let url;
          try { url = new URL(link.getAttribute('href'), window.location.href); } catch { continue; }
          if (!['http:', 'https:'].includes(url.protocol)) continue;
          seen.add(id);
          const excerpt = this.normalize(this.excerpts.get(id));
          records.push({ id, body, name, product, href: url.href, rating, ratingLabel, excerpt: excerpt && body.includes(excerpt) ? excerpt : body });
        }
        if (!records.length) {
          this.records = [];
          this.signature = null;
          this.carousel.hidden = true;
          this.source.hidden = false;
          this.track.replaceChildren();
          this.dots.replaceChildren();
          return;
        }
        const signature = JSON.stringify(records);
        if (signature === this.signature) return;
        const activeId = this.records?.[this.activeIndex()]?.id;
        this.signature = signature;
        this.records = records;
        const cards = document.createDocumentFragment();
        const dots = document.createDocumentFragment();
        records.forEach((record, index) => {
          const card = document.createElement('li');
          card.className = 'sher-home-reviews__item';
          card.dataset.reviewId = record.id;
          const stars = document.createElement('span');
          stars.className = 'sher-home-reviews__stars';
          stars.setAttribute('role', 'img');
          stars.setAttribute('aria-label', record.ratingLabel);
          stars.style.setProperty('--rating-fill', `${record.rating * 20}%`);
          stars.textContent = '★★★★★';
          const quote = document.createElement('blockquote');
          quote.className = 'sher-home-reviews__quote';
          quote.textContent = `“${record.excerpt}”`;
          quote.title = record.body;
          const name = document.createElement('p');
          name.className = 'sher-home-reviews__name';
          name.textContent = record.name;
          const product = document.createElement('a');
          product.className = 'sher-home-reviews__product';
          product.href = record.href;
          product.textContent = record.product;
          card.append(stars, quote, name, product);
          cards.append(card);
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'sher-home-reviews__dot';
          dot.dataset.index = index;
          dot.setAttribute('aria-label', this.dataset.goToLabel.replace('[number]', String(index + 1)));
          dots.append(dot);
        });
        this.track.replaceChildren(cards);
        this.dots.replaceChildren(dots);
        this.carousel.hidden = false;
        this.source.hidden = true;
        this.goTo(Math.max(0, records.findIndex(record => record.id === activeId)), false);
        this.updateNavigation();
      }
      columns() { return Math.max(1, parseInt(getComputedStyle(this).getPropertyValue('--sher-reviews-columns'), 10) || 1); }
      step() { return (this.track.clientWidth + (parseFloat(getComputedStyle(this.track).columnGap) || 24)) / this.columns(); }
      activeIndex() { return Math.max(0, Math.min((this.records?.length || 1) - 1, Math.round(Math.abs(this.track.scrollLeft) / (this.step() || 1)))); }
      goTo(index, animate = true) {
        if (!this.records?.length) return;
        const last = Math.max(0, this.records.length - this.columns());
        const target = Math.max(0, Math.min(index, last));
        const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        const behavior = animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto';
        this.track.scrollTo({ left: direction * target * this.step(), behavior });
      }
      updateNavigation() {
        if (!this.records?.length) return;
        const active = this.activeIndex();
        const last = Math.max(0, this.records.length - this.columns());
        this.previous.disabled = active === 0;
        this.next.disabled = active >= last;
        this.querySelector('[data-review-arrows]').hidden = last === 0;
        this.dots.hidden = this.records.length < 2;
        const start = Math.max(0, Math.min(active - 3, this.records.length - 7));
        Array.from(this.dots.children).forEach((dot, index) => {
          dot.setAttribute('aria-current', String(index === active));
          dot.hidden = index < start || index >= start + 7;
        });
        this.status.textContent = this.dataset.positionLabel.replace('[number]', String(active + 1)).replace('[total]', String(this.records.length));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sher-materials-care"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sher-materials-care')){
  customElements.define('sher-materials-care',class extends HTMLElement{
    connectedCallback(){
      if(this.bound)return;
      this.bound=true;
      this.tabs=[...this.querySelectorAll('[data-material]')];
      this.panels=[...this.querySelectorAll('[data-care-panel]')];
      this.querySelector('.smc-tabs').setAttribute('role','tablist');
      this.tabs.forEach((tab,index)=>{
        tab.setAttribute('role','tab');
        tab.setAttribute('aria-controls',tab.dataset.material);
        tab.addEventListener('click',event=>{
          event.preventDefault();
          this.activate(tab.dataset.material,false,true);
        });
        tab.addEventListener('keydown',event=>{
          let next;
          if(event.key==='ArrowRight')next=(index+1)%this.tabs.length;
          if(event.key==='ArrowLeft')next=(index+this.tabs.length-1)%this.tabs.length;
          if(event.key==='Home')next=0;
          if(event.key==='End')next=this.tabs.length-1;
          if(event.key===' '){event.preventDefault();this.activate(tab.dataset.material,false,true);return;}
          if(next!==undefined){event.preventDefault();this.activate(this.tabs[next].dataset.material,true,true);}
        });
      });
      this.panels.forEach(panel=>{panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',this.tabs.find(tab=>tab.dataset.material===panel.dataset.carePanel).id);panel.tabIndex=0;});
      this.onHash=()=>this.activate(location.hash.slice(1));
      window.addEventListener('hashchange',this.onHash);
      this.onHash();
    }
    disconnectedCallback(){window.removeEventListener('hashchange',this.onHash);this.bound=false;}
    activate(name,focus=false,update=false){
      if(name==='vermeil')name='silver';
      const selected=this.tabs.find(tab=>tab.dataset.material===name)||this.tabs[0];
      this.tabs.forEach(tab=>{const active=tab===selected;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;});
      this.panels.forEach(panel=>panel.hidden=panel.dataset.carePanel!==selected.dataset.material);
      if(focus)selected.focus();
      if(update)history.replaceState(null,'','#'+selected.dataset.material);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sher-whats-in-box"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sher-box-carousel')) {
    customElements.define('sher-box-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('.sher-box__track');
        this.items = [...this.querySelectorAll('.sher-box__item')];
        this.dots = [...this.querySelectorAll('[data-box-index]')];
        this.previous = this.querySelector('[data-box-previous]');
        this.next = this.querySelector('[data-box-next]');
        this.index = 0;
        const update = () => {
          const trackLeft = this.track.getBoundingClientRect().left;
          const distances = this.items.map(item => Math.abs(item.getBoundingClientRect().left - trackLeft));
          this.index = distances.indexOf(Math.min(...distances));
          this.dots.forEach((dot, index) => {
            if (index === this.index) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          this.previous.disabled = this.track.scrollLeft <= 2;
          this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
        };
        const go = index => {
          const item = this.items[Math.max(0, Math.min(this.items.length - 1, index))];
          const left = this.track.scrollLeft + item.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
          this.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.previous.addEventListener('click', () => go(this.index - 1), options);
        this.next.addEventListener('click', () => go(this.index + 1), options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => go(index), options));
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(update);
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, options);
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.track);
        update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
